import cn from "classnames";
import { Datetime } from "components/shared/form";
import React, { useState } from "react";
import { startCollecting } from "sources/admin/registryPoints";

const CollectRegistryPoints = (props) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});

    const saveData = (e) => {
        e.preventDefault();
        setLoading(true);
        startCollecting(data).then((res) => {
            setLoading(false);
            if (res) {
                props.back();
            }
        });
    };

    const renderDateField = (name, fieldProps = {}) => {
        const value = data[name];
        const onFieldChange = ({ value }) => setData({ ...data, [name]: value });
        return (
            <Datetime
                inputProps={{ name }}
                value={value}
                onChange={onFieldChange}
                {...fieldProps}
                labelWrapper="col-sm-6 col-form-label col-form-label-sm text-md-right text-sm-left"
                wrapper="col-sm-6"
                inPortal
            />
        );
    };

    return (
        <form className={cn({ loading })} onSubmit={saveData}>
            {renderDateField("from", { label: "Дата начала периода" })}
            {renderDateField("to", { label: "Дата окончения периода" })}
            <button className="btn btn-sm btn-brand float-right" type="submit">
                Сохранить
            </button>
        </form>
    );
};

export default CollectRegistryPoints;
